import PropTypes from "prop-types";
import { ReactComponent as ErrorBlack } from "../../../../assets/img/icon/wifi_off_black_24dp.svg";

const BlinkAlert = ({ show }) => {
  return (
    <div
      className={
        "fixed left-0 right-0 bg-gray-900 bg-opacity-40 px-2 h-0  " +
        (show ? "opacity-100" : "opacity-30")
      }
      style={{ zIndex: show ? "40" : "-10" }}
    >
      <div
        className={
          "max-w-sm md:max-w-xl bg-white shadow mx-auto p-4 rounded-xl duration-75 ease-in transform " +
          (show ? "opacity-100" : "opacity-30")
        }
      >
        <div className="flex space-y-1 md:space-y-0 space-x-0 md:space-x-4 items-center flex-col md:flex-row">
          <div>
            <ErrorBlack className="w-12 h-12 mx-auto fill-current animate-pulse text-warning" />
          </div>
          <div className="">
            <div className="font-semibold text-lg text-center md:text-left">
              Perhatian
            </div>
            <div className="mt-1 md:mt-0 text-base">
              Koneksi respinos tidak stabil. Mungkin ada data yang hilang.
              Periksa kembali jaringan internet anda.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

BlinkAlert.propsTypes = {
  show: PropTypes.bool.isRequired,
};
export default BlinkAlert;
